/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Component, OnDestroy, OnInit } from '@angular/core';

import { AuthorableComponent } from '@core/aem/models/authorable-component.model';
import { BulletPointData } from './interface/bullet-text-interface';

@Component({
  selector: 'tmo-bullet-text-authorable',
  templateUrl: './bullet-text-authorable.html',
})
export class BulletTextAuthorableComponent
  extends AuthorableComponent<BulletPointData>
  implements OnInit, OnDestroy
{
  /**
   * Stores Auth content data
   */
  public authContent: BulletPointData;
  /**
   * Variable to check seeMore
   */
  public seeMoreLink: boolean;
  /**
   * Variable to check seeLess
   */
  public seeLessLink: boolean;
  /**
   * Variable of Array for bulletPoints
   */
  public bulletPoints: string[];

  constructor() {
    super();
  }
  /**
   * OnInit method.
   * @memberof BulletTextAuthorableComponent
   */
  public ngOnInit(): void {}
  /**
   * method for set Data
   * @param {BulletPointData} data
   * @returns void
   * @memberof BulletTextAuthorableComponent
   */
  public setData(data: BulletPointData): void {
    if (this.validate(data)) {
      this.authContent = data;
      this.seeMoreLink = false;
      this.seeLessLink = true;
      const startIndex = 0;
      const endIndex = this.authContent.bulletControl;
      if (
        this.authContent &&
        this.authContent.bulletPoints &&
        this.authContent.bulletPoints.length > 0
      ) {
        this.bulletPoints = this.authContent.bulletPoints.slice(startIndex, endIndex);
      }
    }
  }

  /**
   * To check validation of data.
   * @param {BulletPointData} data
   * @returns {boolean}
   * @memberof BulletTextAuthorableComponent
   */
  public validate(data: BulletPointData): boolean {
    if (data) {
      return true;
    } else {
      throw new Error(`TemplateComponent: Invalid params ${data}, required fields: ['html']`);
    }
  }

  /**
   * Cleans component on lifecycle hook
   * @returns void
   * @memberof BulletTextAuthorableComponent
   */
  public ngOnDestroy(): void {}

  /**
   * Method for seeLess functionlity
   * @returns void
   * @memberof BulletTextAuthorableComponent
   */
  public seeLess(): void {
    this.seeMoreLink = false;
    this.seeLessLink = true;
    const startIndex = 0;
    const endIndex = this.authContent.bulletControl;
    if (
      this.authContent &&
      this.authContent.bulletPoints &&
      this.authContent.bulletPoints.length > 0
    ) {
      this.bulletPoints = this.authContent.bulletPoints.slice(startIndex, endIndex);
    }
  }

  /**
   *  Method for seeMore functionality
   * @returns void
   * @memberof BulletTextAuthorableComponent
   */
  public seeMore(): void {
    this.seeMoreLink = true;
    this.seeLessLink = false;
    if (
      this.authContent &&
      this.authContent.bulletPoints &&
      this.authContent.bulletPoints.length > 0
    ) {
      this.bulletPoints = this.authContent.bulletPoints;
    }
  }
}
